import * as React from 'react';
import { TranslationService } from "../../common";
import { IntelligentPhotoCatureImageConstant } from '../constants';
import { IntelligentPhotoCaptureLoading } from './intelligentComponents';
import { GuidedPhotoCapture } from '../enums';
export const DownloadArtifactLoader = ({ coCode, contextId, workItemStatus, photoCaptureIntelligentGetDownloadAuthDetailsDataAction, onGPCSuccess, isMic, onGPCError, evaluationDocId, questionnaireId, downloadArtifactAuthDetailsInfo }) => {
    const [isInitialized, setIsInitialized] = React.useState(false);
    const translateFn = TranslationService.translate;
    React.useEffect(() => {
        photoCaptureIntelligentGetDownloadAuthDetailsDataAction(coCode, contextId);
    }, []);
    React.useEffect(() => {
        if (workItemStatus && workItemStatus !== GuidedPhotoCapture.TASK_STATUS_CLOSED) {
            setIsInitialized(true);
            onGPCError(workItemStatus);
        }
        else if ((downloadArtifactAuthDetailsInfo && downloadArtifactAuthDetailsInfo.downloadLinkExpired) ||
            (evaluationDocId && questionnaireId)) {
            setIsInitialized(true);
            onGPCSuccess();
        }
    }, [workItemStatus, evaluationDocId, questionnaireId]);
    return (React.createElement(React.Fragment, null, !isInitialized && (React.createElement(IntelligentPhotoCaptureLoading, { logoSrc: IntelligentPhotoCatureImageConstant.photoCaptureLoader.image, altText: translateFn(IntelligentPhotoCatureImageConstant.photoCaptureLoader.altText), loadingMessage: translateFn(IntelligentPhotoCatureImageConstant.photoCaptureLoader.loadingMessage), title: translateFn(IntelligentPhotoCatureImageConstant.photoCaptureLoader.title), isMic: isMic }))));
};
//# sourceMappingURL=DownloadArtifactLoader.js.map